(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-vmx-featured-fitment]').forEach(function(root){
  if(root.dataset.vmxFeaturedFitmentReady)return;
  root.dataset.vmxFeaturedFitmentReady='1';
  var controls=root.querySelector('[data-vmx-featured-fitment-controls]');
  var modes=Array.from(root.querySelectorAll('[data-vmx-featured-mode]'));
  var views=Array.from(root.querySelectorAll('[data-vmx-featured-view]'));
  var brand=root.querySelector('[data-vmx-featured-brand]');
  var model=root.querySelector('[data-vmx-featured-model]');
  var width=root.querySelector('[data-vmx-featured-width]');
  var mount=root.querySelector('[data-vmx-featured-mount]');
  var reset=root.querySelector('[data-vmx-featured-reset]');
  var status=root.querySelector('[data-vmx-featured-status]');
  var items=Array.from(root.querySelectorAll('[data-vmx-product-handle]'));
  var dataUrl=root.dataset.vmxDataUrl;
  if(!controls||!brand||!model||!width||!mount||!items.length||!dataUrl)return;
  function uniquePush(list,value){if(value&&list.indexOf(value)<0)list.push(value)}
  function setStatus(text){if(status)status.textContent=text}
  function setVisible(handles,message){
    var filtered=Array.isArray(handles);
    var visibleCount=0;
    items.forEach(function(item){
      var show=!filtered||handles.indexOf(item.dataset.vmxProductHandle)>-1;
      item.hidden=!show;
      if(show)visibleCount+=1;
    });
    reset.hidden=!filtered;
    if(message){setStatus(message);return}
    setStatus(filtered?(visibleCount?visibleCount+' matching pads shown.':'No matching pads are shown in this section.'):'Choose a filter to narrow the product list.');
  }
  function showMode(mode){
    modes.forEach(function(button){
      var active=button.dataset.vmxFeaturedMode===mode;
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-selected',String(active));
    });
    views.forEach(function(view){view.hidden=view.dataset.vmxFeaturedView!==mode});
    setVisible(null);
  }
  modes.forEach(function(button){button.addEventListener('click',function(){showMode(button.dataset.vmxFeaturedMode)})});
  fetch(dataUrl).then(function(response){return response.json()}).then(function(data){
    data.f.forEach(function(entry){
      var option=document.createElement('option');
      option.value=entry.b;
      option.textContent=entry.b;
      brand.appendChild(option);
    });
    var widths=[],mounts=[];
    Object.keys(data.p).forEach(function(handle){
      uniquePush(widths,data.p[handle].s);
      uniquePush(mounts,data.p[handle].m);
    });
    widths.sort(function(a,b){return parseInt(a,10)-parseInt(b,10)}).forEach(function(value){
      var option=document.createElement('option');
      option.value=value;
      option.textContent=value;
      width.appendChild(option);
    });
    mounts.sort().forEach(function(value){
      var option=document.createElement('option');
      option.value=value;
      option.textContent=value;
      mount.appendChild(option);
    });
    function getBrand(){return data.f.find(function(entry){return entry.b===brand.value})}
    function handlesForMachine(selectedBrand,selectedModel){
      var handles=[];
      if(!selectedBrand)return handles;
      selectedBrand.g.forEach(function(group){
        if(!selectedModel||group.m.indexOf(selectedModel)>-1){
          group.p.forEach(function(handle){uniquePush(handles,handle)});
        }
      });
      return handles;
    }
    function updateSize(){
      if(!width.value&&!mount.value){setVisible(null);return}
      var handles=[];
      Object.keys(data.p).forEach(function(handle){
        var product=data.p[handle];
        if((!width.value||product.s===width.value)&&(!mount.value||product.m===mount.value))handles.push(handle);
      });
      setVisible(handles);
    }
    brand.addEventListener('change',function(){
      var selectedBrand=getBrand();
      model.innerHTML='<option value="">All models</option>';
      model.disabled=!selectedBrand;
      if(!selectedBrand){setVisible(null);return}
      var models=[];
      selectedBrand.g.forEach(function(group){group.m.forEach(function(name){uniquePush(models,name)})});
      models.sort().forEach(function(name){
        var option=document.createElement('option');
        option.value=name;
        option.textContent=name;
        model.appendChild(option);
      });
      setVisible(handlesForMachine(selectedBrand,''));
    });
    model.addEventListener('change',function(){
      var selectedBrand=getBrand();
      if(selectedBrand)setVisible(handlesForMachine(selectedBrand,model.value));
    });
    width.addEventListener('change',updateSize);
    mount.addEventListener('change',updateSize);
    reset.addEventListener('click',function(){
      brand.value='';
      model.innerHTML='<option value="">All models</option>';
      model.disabled=true;
      width.value='';
      mount.value='';
      setVisible(null);
    });
  }).catch(function(){
    setStatus('Product filters are temporarily unavailable.');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vmx-customer-installations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vmx-wall-carousel]').forEach(function(root) {
    if (root.dataset.vmxWallReady) return;
    root.dataset.vmxWallReady = 'true';
    var pages = Array.prototype.slice.call(root.querySelectorAll('[data-vmx-wall-page]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-vmx-wall-dot]'));
    var current = 0;
    function show(index) {
      current = (index + pages.length) % pages.length;
      pages.forEach(function(page, i) { page.hidden = i !== current; });
      dots.forEach(function(dot, i) { i === current ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'); });
    }
    root.querySelector('[data-vmx-wall-previous]').addEventListener('click', function() { show(current - 1); });
    root.querySelector('[data-vmx-wall-next]').addEventListener('click', function() { show(current + 1); });
    dots.forEach(function(dot) { dot.addEventListener('click', function() { show(Number(dot.dataset.vmxWallDot)); }); });
    var startX = null;
    var carousel = root.querySelector('.vmx-photo-reviews__carousel');
    carousel.addEventListener('touchstart', function(event) { startX = event.changedTouches[0].clientX; }, { passive: true });
    carousel.addEventListener('touchend', function(event) {
      if (startX === null) return;
      var distance = event.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(distance) < 45) return;
      show(distance < 0 ? current + 1 : current - 1);
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vmx-parts-finder"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-vmx-parts-finder]').forEach(function(root){if(root.dataset.vmxReady)return;root.dataset.vmxReady='1';var modes=root.querySelectorAll('[data-vmx-mode]'),panels=root.querySelectorAll('[data-vmx-panel]'),brand=root.querySelector('[data-vmx-brand]'),model=root.querySelector('[data-vmx-model]'),width=root.querySelector('[data-vmx-width]'),mount=root.querySelector('[data-vmx-mount]'),machineForm=root.querySelector('[data-vmx-machine-form]'),sizeForm=root.querySelector('[data-vmx-size-form]'),results=root.querySelector('[data-vmx-results]'),list=root.querySelector('[data-vmx-list]'),dataUrl=root.dataset.vmxDataUrl;function esc(v){return String(v||'').replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}function showMode(mode){modes.forEach(function(button){var active=button.dataset.vmxMode===mode;button.classList.toggle('is-active',active);button.setAttribute('aria-selected',String(active))});panels.forEach(function(panel){panel.hidden=panel.dataset.vmxPanel!==mode})}function render(data,handles,emptyMessage){results.hidden=false;if(!handles.length){list.innerHTML='<div class="vmx-fitment-empty">'+emptyMessage+'</div>';return}list.innerHTML=handles.map(function(h){var p=data.p[h];return p?'<a class="vmx-fitment-card" href="'+esc(p.u)+'"><strong>'+esc(p.t)+'</strong><span>'+esc(p.s)+' / '+esc(p.m)+'</span><span>View product</span></a>':''}).join('');results.scrollIntoView({behavior:'smooth',block:'start'})}modes.forEach(function(button){button.addEventListener('click',function(){showMode(button.dataset.vmxMode)})});fetch(dataUrl).then(function(r){return r.json()}).then(function(data){data.f.forEach(function(item){var option=document.createElement('option');option.value=item.b;option.textContent=item.b;brand.appendChild(option)});var widths=[],mounts=[];Object.keys(data.p).forEach(function(handle){var product=data.p[handle];if(product.s&&widths.indexOf(product.s)<0)widths.push(product.s);if(product.m&&mounts.indexOf(product.m)<0)mounts.push(product.m)});widths.sort(function(a,b){return parseInt(a,10)-parseInt(b,10)}).forEach(function(value){var option=document.createElement('option');option.value=value;option.textContent=value+' (approx. '+Math.round(parseInt(value,10)/25.4)+' in)';width.appendChild(option)});mounts.sort().forEach(function(value){var option=document.createElement('option');option.value=value;option.textContent=value;mount.appendChild(option)});brand.addEventListener('change',function(){model.innerHTML='<option value="">Select model</option>';model.disabled=!brand.value;if(!brand.value)return;var found=data.f.find(function(item){return item.b===brand.value}),models=[];(found?found.g:[]).forEach(function(group){group.m.forEach(function(value){if(models.indexOf(value)<0)models.push(value)})});models.sort().forEach(function(value){var option=document.createElement('option');option.value=value;option.textContent=value;model.appendChild(option)})});machineForm.addEventListener('submit',function(event){event.preventDefault();var found=data.f.find(function(item){return item.b===brand.value}),handles=[];(found?found.g:[]).forEach(function(group){if(group.m.indexOf(model.value)>-1){group.p.forEach(function(handle){if(handles.indexOf(handle)<0)handles.push(handle)})}});render(data,handles,'No exact model match is listed yet. Try searching by track width and mounting style, or contact us for fitment help.')});sizeForm.addEventListener('submit',function(event){event.preventDefault();var handles=[];Object.keys(data.p).forEach(function(handle){var product=data.p[handle];if(product.s===width.value&&product.m===mount.value)handles.push(handle)});render(data,handles,'No product currently matches this width and mounting style. Contact us for fitment help.')})}).catch(function(){results.hidden=false;list.innerHTML='<div class="vmx-fitment-empty">The fitment data could not be loaded. Please refresh the page or contact us for help.</div>'})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vmx-product-description"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-vmx-product-tabs]').forEach(function(root){if(root.dataset.vmxTabsReady)return;root.dataset.vmxTabsReady='1';var tabs=Array.from(root.querySelectorAll('[data-vmx-tab]')),panels=Array.from(root.querySelectorAll('[data-vmx-panel]')),handle=root.dataset.productHandle,list=root.querySelector('[data-vmx-fitment-list]'),url=root.dataset.vmxDataUrl,fitmentTab=root.querySelector('[data-vmx-tab="fitment"]'),fitmentPanel=root.querySelector('[data-vmx-panel="fitment"]');function esc(v){return String(v||'').replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}function visibleTabs(){return tabs.filter(function(tab){return !tab.hidden})}function activate(tab,focus){if(!tab||tab.hidden)return;var key=tab.dataset.vmxTab;tabs.forEach(function(item){var active=item===tab;item.classList.toggle('is-active',active);item.setAttribute('aria-selected',active?'true':'false');item.tabIndex=active?0:-1});panels.forEach(function(panel){panel.hidden=panel.dataset.vmxPanel!==key});if(focus)tab.focus()}function hideFitment(){if(fitmentTab){fitmentTab.hidden=true;fitmentTab.setAttribute('aria-hidden','true');fitmentTab.tabIndex=-1;fitmentTab.classList.remove('is-active');fitmentTab.setAttribute('aria-selected','false')}if(fitmentPanel)fitmentPanel.hidden=true;var active=root.querySelector('[data-vmx-tab].is-active');if(!active||active.hidden)activate(visibleTabs()[0],false)}tabs.forEach(function(tab,index){tab.tabIndex=index===0?0:-1;tab.addEventListener('click',function(){activate(tab,false)});tab.addEventListener('keydown',function(event){var items=visibleTabs();var current=items.indexOf(tab);var target=current;if(event.key==='ArrowRight')target=(current+1)%items.length;else if(event.key==='ArrowLeft')target=(current-1+items.length)%items.length;else if(event.key==='Home')target=0;else if(event.key==='End')target=items.length-1;else return;event.preventDefault();activate(items[target],true)})});fetch(url).then(function(response){return response.json()}).then(function(data){var byBrand={};(data.f||[]).forEach(function(brand){(brand.g||[]).forEach(function(group){if((group.p||[]).indexOf(handle)>-1){(group.m||[]).forEach(function(model){(byBrand[brand.b]=byBrand[brand.b]||[]).push(model)})}})});var brands=Object.keys(byBrand).sort(function(a,b){var priority={Caterpillar:0,Komatsu:1};var ap=Object.prototype.hasOwnProperty.call(priority,a)?priority[a]:2;var bp=Object.prototype.hasOwnProperty.call(priority,b)?priority[b]:2;return ap-bp||a.localeCompare(b)});if(!brands.length){hideFitment();return}list.innerHTML=brands.map(function(brand){var models=byBrand[brand].filter(function(model,index,array){return array.indexOf(model)===index}).sort();return '<p class="vmx-product-tabs__fitment-line"><strong>'+esc(brand)+':</strong> '+models.map(esc).join(', ')+'</p>'}).join('')}).catch(function(){hideFitment()})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vmx-steps"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function prepare() {
      document.querySelectorAll('[data-vmx-home-service-bg]').forEach(function(section) {
        if (section.dataset.vmxBgReady) return;
        section.dataset.vmxBgReady = 'true';

        function loadBackground() {
          var source = window.matchMedia('(max-width: 989px)').matches
            ? section.dataset.vmxBgMobile
            : section.dataset.vmxBgDesktop;
          if (source) section.style.setProperty('--vmx-bg', 'url("' + source + '")');
        }

        if (!('IntersectionObserver' in window)) {
          loadBackground();
          return;
        }

        var observer = new IntersectionObserver(function(entries) {
          if (!entries[0].isIntersecting) return;
          loadBackground();
          observer.disconnect();
        }, { rootMargin: '800px 0px' });
        observer.observe(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', prepare);
    } else {
      prepare();
    }
    document.addEventListener('shopify:section:load', prepare);
  })();

  } catch(e) { console.error(e); }
})();
})();
